import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import type { ILink } from './useHeaderLinks'

export const useMegamenuLinks = () => {
	const t = useTranslations('layout.header')

	const megamenuLinks: ILink[] = useMemo(
		() => [
			{
				label: t('megamenu_links.home.label'),
				to: '/'
			},
			{
				label: t('megamenu_links.services.label'),
				to: '/services',
				children: [
					{
						label: t('megamenu_links.services.children.ambulanceVisit'),
						to: '/ambulancie',
						prefetch: true
					},
					{
						label: t('megamenu_links.services.children.annualPrograms'),
						to: '/rocne-programy',
						prefetch: true
					},
					{
						label: t('megamenu_links.services.children.preventiveExaminations'),
						to: '/preventivne-prehliadky',
						prefetch: true
					},
					{
						label: t('megamenu_links.services.children.medanteCredit'),
						to: '/medante-kredit',
						prefetch: true
					},
					{
						label: t('megamenu_links.services.children.vipCare'),
						to: '/rocne-programy/medante-platinum',
						prefetch: true
					}
				]
			},
			{
				label: t('megamenu_links.ambulances.label'),
				to: '/ambulancie',
				prefetch: true
			},
			{
				label: t('megamenu_links.team.label'),
				to: '/tim',
				prefetch: true
			},
			{
				label: t('megamenu_links.forCompanies.label'),
				to: '/pre-firmy',
				prefetch: true
			},
			{
				label: t('megamenu_links.blog.label'),
				to: '/clanky',
				prefetch: true
			},
			{
				label: t('megamenu_links.jobs.label'),
				to: '/kariera',
				prefetch: true,
				children: [
					{
						label: t('megamenu_links.jobs.children.openPositions'),
						to: '/kariera',
						prefetch: true,
						activeExcludeNextSegments: [
							'podte-robit-svet-zdravsim',
							'lets-make-world-healthier'
						]
					},
					{
						label: t('megamenu_links.jobs.children.makeWorldHealthier'),
						to: '/kariera/podte-robit-svet-zdravsim',
						prefetch: true
					}
				]
			},
			{
				label: t('megamenu_links.discounts.label'),
				to: '/akciova-ponuka',
				prefetch: true
			},
			{
				label: t('links.podcasts.label'),
				to: '/clanky?category=podcasty',
				highlight: false
			},
			{
				label: t('megamenu_links.references.label'),
				to: '/povedali-o-nas',
				prefetch: true
			},
			{
				label: t('megamenu_links.faq.label'),
				to: '/casto-kladene-otazky',
				prefetch: true
			},
			{
				label: t('megamenu_links.contact.label'),
				to: '/kontakt',
				prefetch: true
			}
		],
		[t]
	)

	return megamenuLinks
}
